// NOTE: RuleMode (ALL/NONE/CUSTOM) は意図的に i18n しない。ruleMode キーは持たない。
const featuresDeviceGroupEn = {
  components: {
    basicCard: {
      intendedUse: 'Intended use',
      name: 'Name',
      title: 'Basic Information'
    },
    confirm: {
      previewError: 'Failed to load preview. Please check your conditions and try again.',
      searchPlaceholder: 'Search by device name...',
      summary: {
        totalCount: 'Total devices'
      }
    },
    deviceGenreFilter: {
      all: 'All types',
      label: 'Device type'
    },
    devicesInGroupCard: {
      searchPlaceholder: 'Search by device name...',
      title: 'Devices in Group'
    },
    devicesInGroupTable: {
      columns: {
        assignee: 'Current assignee',
        genre: 'Device type',
        name: 'Device name',
        status: 'Status'
      }
    },
    genreRuleCard: {
      addCatalog: 'Add catalog',
      catalogField: 'Catalog',
      mode: {
        ALL: 'All',
        CONDITIONAL: 'Conditional',
        NONE: 'None'
      },
      noCandidates: 'No more catalogs to add',
      noConditions: 'No conditions',
      opExclude: 'Exclude',
      opInclude: 'Include'
    },
    genreRulesCard: {
      genreRulesSection: 'Condition',
      individualSection: 'Individual',
      title: 'Group Definition'
    },
    individualDeviceCard: {
      excludeLabel: 'Exclude',
      includeLabel: 'Include',
      noCandidates: 'No more devices to add',
      removeDevice: 'Remove device',
      searchPlaceholder: 'Search devices...'
    }
  }
};
export default featuresDeviceGroupEn;